/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WhiteInputs */

const en_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White`)
};

const es_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blanco`)
};

const fr_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blanc`)
};

const de_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weißwein`)
};

const ja_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白ワイン`)
};

const zh_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白葡萄酒`)
};

const ar_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ أبيض`)
};

const id_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putih`)
};

const it_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bianco`)
};

const ru_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Белое`)
};

const pt_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branco`)
};

const ko_val_white = /** @type {(inputs: Val_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화이트`)
};

/**
* | output |
* | --- |
* | "White" |
*
* @param {Val_WhiteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_white = /** @type {((inputs?: Val_WhiteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WhiteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_white(inputs)
	if (locale === "es") return es_val_white(inputs)
	if (locale === "fr") return fr_val_white(inputs)
	if (locale === "de") return de_val_white(inputs)
	if (locale === "ja") return ja_val_white(inputs)
	if (locale === "zh") return zh_val_white(inputs)
	if (locale === "ar") return ar_val_white(inputs)
	if (locale === "id") return id_val_white(inputs)
	if (locale === "it") return it_val_white(inputs)
	if (locale === "ru") return ru_val_white(inputs)
	if (locale === "pt") return pt_val_white(inputs)
	return ko_val_white(inputs)
});